module.exports = __webpack_public_path__ + "static/media/playtech.a630428c.webp";